"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetCreateRequestToJSON = exports.AdSetCreateRequestFromJSONTyped = exports.AdSetCreateRequestFromJSON = exports.instanceOfAdSetCreateRequest = void 0;
var runtime_1 = require("../runtime");
var AspectRatio_1 = require("./AspectRatio");
var AssetFormat_1 = require("./AssetFormat");
var BidStrategyRequest_1 = require("./BidStrategyRequest");
var BudgetRequest_1 = require("./BudgetRequest");
var CostModel_1 = require("./CostModel");
var Delivery_1 = require("./Delivery");
var DeliveryGoal_1 = require("./DeliveryGoal");
var DuplicationType_1 = require("./DuplicationType");
var FeatureFlag_1 = require("./FeatureFlag");
var FrequencyCap_1 = require("./FrequencyCap");
var Pacing_1 = require("./Pacing");
var Placement_1 = require("./Placement");
var Promotion_1 = require("./Promotion");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the AdSetCreateRequest interface.
 */
function instanceOfAdSetCreateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "bidMicroAmount" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "budget" in value;
    isInstance = isInstance && "targets" in value;
    isInstance = isInstance && "bidStrategy" in value;
    isInstance = isInstance && "assetFormat" in value;
    return isInstance;
}
exports.instanceOfAdSetCreateRequest = instanceOfAdSetCreateRequest;
function AdSetCreateRequestFromJSON(json) {
    return AdSetCreateRequestFromJSONTyped(json, false);
}
exports.AdSetCreateRequestFromJSON = AdSetCreateRequestFromJSON;
function AdSetCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'startTime': (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'bidMicroAmount': json['bid_micro_amount'],
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'spanFreezeAt': !(0, runtime_1.exists)(json, 'span_freeze_at') ? undefined : (new Date(json['span_freeze_at'])),
        'iasCampaignId': !(0, runtime_1.exists)(json, 'ias_campaign_id') ? undefined : json['ias_campaign_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'category': json['category'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : json['categories'],
        'budget': (0, BudgetRequest_1.BudgetRequestFromJSON)(json['budget']),
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel_1.CostModelFromJSON)(json['cost_model']),
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'overbooked': !(0, runtime_1.exists)(json, 'overbooked') ? undefined : json['overbooked'],
        'pacing': !(0, runtime_1.exists)(json, 'pacing') ? undefined : (0, Pacing_1.PacingFromJSON)(json['pacing']),
        'rateCardType': !(0, runtime_1.exists)(json, 'rate_card_type') ? undefined : json['rate_card_type'],
        'bidStrategy': (0, BidStrategyRequest_1.BidStrategyRequestFromJSON)(json['bid_strategy']),
        'promotion': !(0, runtime_1.exists)(json, 'promotion') ? undefined : (0, Promotion_1.PromotionFromJSON)(json['promotion']),
        'campaignId': !(0, runtime_1.exists)(json, 'campaign_id') ? undefined : json['campaign_id'],
        'assetFormat': (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'guaranteed': !(0, runtime_1.exists)(json, 'guaranteed') ? undefined : json['guaranteed'],
        'copiedAdSetId': !(0, runtime_1.exists)(json, 'copied_ad_set_id') ? undefined : json['copied_ad_set_id'],
        'draftId': !(0, runtime_1.exists)(json, 'draft_id') ? undefined : json['draft_id'],
        'duplicationType': !(0, runtime_1.exists)(json, 'duplication_type') ? undefined : (0, DuplicationType_1.DuplicationTypeFromJSON)(json['duplication_type']),
        'aspectRatio': !(0, runtime_1.exists)(json, 'aspect_ratio') ? undefined : (0, AspectRatio_1.AspectRatioFromJSON)(json['aspect_ratio']),
        'duplicatedAdSetId': !(0, runtime_1.exists)(json, 'duplicated_ad_set_id') ? undefined : json['duplicated_ad_set_id'],
        'mobileAppId': !(0, runtime_1.exists)(json, 'mobile_app_id') ? undefined : json['mobile_app_id'],
        'reservationId': !(0, runtime_1.exists)(json, 'reservation_id') ? undefined : json['reservation_id'],
        'placements': !(0, runtime_1.exists)(json, 'placements') ? undefined : (json['placements'].map(Placement_1.PlacementFromJSON)),
        'isSurvey': !(0, runtime_1.exists)(json, 'is_survey') ? undefined : json['is_survey'],
        'featureFlags': !(0, runtime_1.exists)(json, 'feature_flags') ? undefined : (json['feature_flags'].map(FeatureFlag_1.FeatureFlagFromJSON)),
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'deliveryGoal': !(0, runtime_1.exists)(json, 'delivery_goal') ? undefined : (0, DeliveryGoal_1.DeliveryGoalFromJSON)(json['delivery_goal']),
    };
}
exports.AdSetCreateRequestFromJSONTyped = AdSetCreateRequestFromJSONTyped;
function AdSetCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'start_time': (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'bid_micro_amount': value.bidMicroAmount,
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'dataset_id': value.datasetId,
        'span_freeze_at': value.spanFreezeAt === undefined ? undefined : (value.spanFreezeAt.toISOString()),
        'ias_campaign_id': value.iasCampaignId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'category': value.category,
        'categories': value.categories,
        'budget': (0, BudgetRequest_1.BudgetRequestToJSON)(value.budget),
        'cost_model': (0, CostModel_1.CostModelToJSON)(value.costModel),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'overbooked': value.overbooked,
        'pacing': (0, Pacing_1.PacingToJSON)(value.pacing),
        'rate_card_type': value.rateCardType,
        'bid_strategy': (0, BidStrategyRequest_1.BidStrategyRequestToJSON)(value.bidStrategy),
        'promotion': (0, Promotion_1.PromotionToJSON)(value.promotion),
        'campaign_id': value.campaignId,
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'guaranteed': value.guaranteed,
        'copied_ad_set_id': value.copiedAdSetId,
        'draft_id': value.draftId,
        'duplication_type': (0, DuplicationType_1.DuplicationTypeToJSON)(value.duplicationType),
        'aspect_ratio': (0, AspectRatio_1.AspectRatioToJSON)(value.aspectRatio),
        'duplicated_ad_set_id': value.duplicatedAdSetId,
        'mobile_app_id': value.mobileAppId,
        'reservation_id': value.reservationId,
        'placements': value.placements === undefined ? undefined : (value.placements.map(Placement_1.PlacementToJSON)),
        'is_survey': value.isSurvey,
        'feature_flags': value.featureFlags === undefined ? undefined : (value.featureFlags.map(FeatureFlag_1.FeatureFlagToJSON)),
        'salesforce_line_item_id': value.salesforceLineItemId,
        'delivery_goal': (0, DeliveryGoal_1.DeliveryGoalToJSON)(value.deliveryGoal),
    };
}
exports.AdSetCreateRequestToJSON = AdSetCreateRequestToJSON;
